import { type Staff } from '../../models';
import { useBusinessStore } from '../../store';
import { BOOLEAN_VALUE } from '../../types';
import { useUserInfoState } from '../use-user-info';

export function useUserAccess() {
    const { businessInfo } = useBusinessStore();
    const { value: defaultUser, isLoading: isLoadingUser } = useUserInfoState();

    const businessId = businessInfo.businessId;

    const canAccess = (
        access: string[],
        grantAccessIfAny = false,
        user?: Staff,
    ) => {
        if (!businessId) {
            return false;
        }

        const currentUser = user ?? defaultUser;

        if (!access?.length || currentUser?.superRole === BOOLEAN_VALUE.TRUE) {
            return true;
        }

        const computedPermissions = currentUser?.permissionList as string[];

        if (grantAccessIfAny) {
            return access.some((key) => computedPermissions?.includes(key));
        }

        return access.every((key) => computedPermissions?.includes(key));
    };

    return { canAccess, isLoadingUser };
}
